import { c as _c } from "react/compiler-runtime";
import { IcoCheck16, IcoCopy16 } from '@onefootprint/icons';
import { IconButton, Tooltip } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useEffect, useState } from 'react';
const COPY_FEEDBACK_MS = 1500;
type UserMessageActionsProps = {
  content: string;
  /** Hover state from the parent wrapper — see [[useHoverState]] in message-actions.tsx. */
  visible?: boolean;
};
const UserMessageActions = t0 => {
  const $ = _c(16);
  const {
    content,
    visible
  } = t0;
  const [copied, setCopied] = useState(false);
  let t1;
  if ($[0] !== content) {
    t1 = () => {
      navigator.clipboard.writeText(content);
      setCopied(true);
    };
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleCopy = t1;
  let t2;
  let t3;
  if ($[2] !== copied) {
    t2 = () => {
      if (!copied) {
        return;
      }
      const t = setTimeout(() => setCopied(false), COPY_FEEDBACK_MS);
      return () => clearTimeout(t);
    };
    t3 = [copied];
    $[2] = copied;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  const t4 = visible ? "opacity-100" : "opacity-0 max-md:opacity-100";
  let t5;
  if ($[5] !== t4) {
    t5 = cx("flex items-center transition-opacity focus-within:opacity-100", t4);
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = copied ? "Copied" : "Copy";
  const t7 = copied ? IcoCheck16 : IcoCopy16;
  let t8;
  if ($[7] !== handleCopy || $[8] !== t7) {
    t8 = <IconButton icon={t7} size="tiny" aria-label="Copy message" onClick={handleCopy} />;
    $[7] = handleCopy;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t6 || $[11] !== t8) {
    t9 = <Tooltip content={t6} side="bottom">{t8}</Tooltip>;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t5 || $[14] !== t9) {
    t10 = <div className={t5}>{t9}</div>;
    $[13] = t5;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};
export default UserMessageActions;